import { render, staticRenderFns } from "./SidebarFilters.vue?vue&type=template&id=1adc58aa&scoped=true&"
import script from "./SidebarFilters.vue?vue&type=script&lang=js&"
export * from "./SidebarFilters.vue?vue&type=script&lang=js&"
import style0 from "./SidebarFilters.vue?vue&type=style&index=0&id=1adc58aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adc58aa",
  null
  
)

export default component.exports